import { api } from '../../lib/api';

export interface Filters {
  app: string; period: string; from: string; to: string; plan: string; user: string; excludeInternal: boolean;
  kind: string; signal: string; search: string; sort: string; direction: string; page: number;
}
export interface Person { id: string; email: string; displayName: string | null }
export interface Conversation {
  id: string; app: string; userId: string; storage: 'text' | 'voice'; kind: string; context: string;
  title: string | null; activityAt: string; messages: number; missingSources: number | null;
  negative: number; durationSec: number; user: Person; plan: string; costUsd: number | null;
  partialCalls: number; calls: number; models: string[]; signals: string[];
  recordType?: 'conversation' | 'oral_budget'; dialogSessionId?: string | null; transcriptSource?: string | null;
}
export interface CostRow {
  app: string; user: Person; plan: string; costUsd: number | null; calls: number; tokens: number;
  partialCalls: number; legacyCalls: number; unlinkedCalls: number; voiceSeconds: number; voiceEstimateEur: number;
  bySource: { source: string; costUsd: number }[];
}
interface Result<T> {
  rows: T[]; total: number; page: number; limit: number; hasMore: boolean; generatedAt: string;
  environment: string; range: { from: string | null; until: string; timezone: string }; notes: string[];
}
export interface ConversationResult extends Result<Conversation> {
  summary: { conversations: number; users: number; messages: number; withSignals: number;
    byKind: { label: string; count: number }[]; byContext: { label: string; count: number }[]; signals: { label: string; count: number }[] };
}
export interface CostsResult extends Result<CostRow> {
  summary: { users: number; costUsd: number; calls: number; partialCalls: number; legacyCalls: number;
    voiceEstimateEur: number; unassignedProviderCalls: number; unassignedProviderCostUsd: number | null };
}
export interface Transcript {
  id: string; title: string | null; total: number; offset: number; hasMore: boolean; sourcesAvailable?: boolean;
  messages: { id: string; seq: number; role: string; content: string; createdAt: string | null;
    sources?: unknown; turnMetadata?: unknown; rating?: { rating: string; reason: string | null; reasonText: string | null } | null }[];
  sourceTurns: { assistantMessageId: string; createdAt: string; sources: unknown }[];
}
export function queryString(filters: Filters, costs = false): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(filters)) {
    if (costs && ['kind', 'signal', 'search'].includes(key)) continue;
    if (['from', 'to'].includes(key) && filters.period !== 'custom') continue;
    if (value !== '') params.set(key, String(value));
  }
  return params.toString();
}
export const fetchConversations = (f: Filters) => api.get<ConversationResult>(`/admin/ai-conversations/conversations?${queryString(f)}`);
export const fetchUserCosts = (f: Filters) => api.get<CostsResult>(`/admin/ai-conversations/users?${queryString(f, true)}`);
export const fetchTranscript = (row: Pick<Conversation, 'id' | 'app' | 'storage'>, offset: number) =>
  api.get<Transcript>(`/admin/ai-conversations/transcript?${new URLSearchParams({ id: row.id, app: row.app, storage: row.storage, offset: String(offset) })}`);
